import styled from "@emotion/styled";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { QuestionCommentsSection } from "src/components/NewComponents/Exam/OptionDetails/Comments/QuestionCommentsSection";
import CommentsSkeleton from "src/components/NewComponents/Skeletons/Comments";
import CommentsIcon from "src/images/Icons/newIcons/exam/options/comments.svg";
import { useGetQuestionComments } from "../../../../../hooks/useComments";
import { useFontSize } from "../../../../../hooks/useFontSize";
import DefaultOptionDetail from "../DefaultOptionDetail";

function CommentsOption({
	question,
	dispatch,
	actions,
	settings,
	// opcjonalnie: już pobrane komentarze (domyślne filtry) — bez requestu
	initialComments = undefined,
}) {
	const { fontSizeClass } = useFontSize();
	const { t } = useTranslation();
	const [filters, setFilters] = useState({
		sort: "ASC",
		type: null,
	});

	const { isLoading, data } = useGetQuestionComments(
		question.id,
		filters,
		settings.comments,
		initialComments,
	);

	const renderContent = (comments) => {
		return (
			<QuestionCommentsSection
				question={question}
				comments={comments}
				isActive
				allowReply
				placeholder={t("exam.comments.addComment")}
				filters={filters}
				setSort={(sort) => {
					return setFilters({
						...filters,
						sort,
					});
				}}
				setType={(type) => {
					if (type === filters.type) {
						setFilters({
							...filters,
							type: null,
						});
					} else {
						setFilters({
							...filters,
							type,
						});
					}
				}}
			/>
		);
	};

	if (!settings.comments) {
		return null;
	}

	return (
		<DefaultOptionDetail
			dispatch={dispatch}
			actions={actions}
			isLoading={isLoading}
			data={data}
			renderContent={renderContent}
			isOpen={settings.comments}
			optionKey="comments"
			renderHeader={() => (
				<div className="flex-center-row gap-8">
					<CommentsIcon className="icon-normal" />
					<span className={fontSizeClass}>{t("exam.comments.title")}</span>
				</div>
			)}
			Skeleton={<CommentsSkeleton />}
		/>
	);
}

export default styled(CommentsOption)``;
